export const LATAM_CODE = 'LA';
export const VIVA_AIR_CO_CODE = 'VH';
export const VIVA_AIR_PE_CODE = 'VV';
export const GOL_AIR_CODE = 'G3';
export const AZUL_AIR_CODE = 'AD';
export const UNITED_AIR_CODE = 'UA';
export const VIVA_AIRBUS_CODE = 'VB';
export const VOLARIS_CODE = 'Y4';
export const EASYFLY_AIR_CODE = 'VE';
export const AEROMEXICO_AIR_CODE = 'AM';
export const SKY_AIR_CODE_1 = 'H2';
export const SKY_AIR_CODE_2 = 'H8';
export const AVIANCA_AIR_CODE = 'AV';
export const JETBLUE_AIR_CODE = 'B6';
export const JETSMART_AIR_CODE_1 = 'JA';
export const JETSMART_AIR_CODE_2 = 'JZ';
export const JETSMART_AIR_CODE_3 = 'WJ';
export const COPA_AIR_CODE = 'CM';
export const CLIC_AIR_CODE = 'VE';
export const SATENA_AIR_CODE = '9R';
